import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ZapIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-20 pb-24 px-4 overflow-hidden bg-[#0a0e1a]" data-id="element-97">
      {/* Background glow effects */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-[#c9a84c]/5 rounded-full blur-[120px] pointer-events-none" data-id="element-98" />

      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-99">
        <div className="text-center lg:text-left" data-id="element-100">
          <FadeIn data-id="element-101">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#111827] border border-[#c9a84c]/30 text-[#c9a84c] text-sm font-semibold mb-6" data-id="element-102">
              <ZapIcon className="w-4 h-4" data-id="element-103" />
              <span data-id="element-104">Para hombres de 40+ en Latinoamérica</span>
            </div>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-105">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-[#f5f5f5] leading-tight mb-6" data-id="element-106">
              ¿Sientes que tus mejores años quedaron atrás?{' '}
              <br className="hidden lg:block" data-id="element-107" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#c9a84c] to-[#d4af37]" data-id="element-108">
                Cómo recuperar la Energía, el Enfoque y la Potencia de tus 25...
              </span>
            </h1>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-109">
            <p className="text-xl md:text-2xl text-[#9ca3af] mb-8 font-light" data-id="element-110">
              En solo 28 días y sin pisar un gimnasio ni sacrificar los asados
              del fin de semana.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-111">
            <p className="text-lg text-[#f5f5f5] mb-10 border-l-4 border-[#c9a84c] pl-4 italic" data-id="element-112">
              El Protocolo de "Reajuste Hormonal" diseñado exclusivamente para
              hombres de 40+ en Latinoamérica.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-113">
            <Button href="#comprar" className="w-full sm:w-auto text-lg md:text-xl px-10 py-5" data-id="element-114">
              SÍ, QUIERO RECUPERAR MI ENERGÍA
            </Button>
            <p className="mt-4 inline-flex items-center gap-2 bg-[#c9a84c]/10 border border-[#c9a84c]/30 text-[#c9a84c] text-sm font-bold uppercase tracking-wide px-4 py-2 rounded-full animate-pulse" data-id="element-115">
              <span className="w-2 h-2 bg-[#c9a84c] rounded-full" data-id="element-116" />
              Incluye 3 bonos de regalo completamente GRATIS
            </p>
            <a href="#bono-1" className="mt-2 inline-block text-[#c9a84c]/70 hover:text-[#c9a84c] text-sm underline underline-offset-4 transition-colors" data-id="element-117">
              Leer más
            </a>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} direction="left" className="relative mx-auto w-full max-w-lg lg:max-w-none" data-id="element-118">
          <div className="relative rounded-2xl overflow-hidden shadow-[0_0_50px_rgba(201,168,76,0.15)] border border-[#c9a84c]/20" data-id="element-119">
            <div className="absolute inset-0 bg-gradient-to-t from-[#0a0e1a] via-transparent to-transparent z-10" data-id="element-120" />
            <img src="https://cdn.magicpatterns.com/uploads/mKrxWce1FESZFt9hJ19F2j/heylloyd-image-1772818255775.png" alt="Código Alfa 40+ Sistema Completo" className="w-full h-auto object-cover" data-id="element-121" />
          </div>
        </FadeIn>
      </div>
    </section>;
}